// src/pages/contact.jsx - COMPLETE FILE
import React, { useState } from 'react';
import {Row, Col, Form, Button, Alert } from 'react-bootstrap';
import contactHeaderImg from '../assets/images/header.png';
import manufacturingImage from '../assets/gallery/manufacturing/085.jpeg';
import { 
  FaMapMarkerAlt, 
  FaPhone, 
  FaEnvelope, 
  FaClock, 
  FaHeadset, 
} from 'react-icons/fa';

const Contact = () => {
  const [formData, setFormData] = useState({
  name: '',
  email: '',
  phone: '',
  company: '',
  industry: '',
  inquiryType: 'General Inquiry',
  projectDetails: '',
  message: '',
  website: '' // 🔐 Honeypot field
});


  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const industries = [
    'Manufacturing',
    'Infrastructure & Construction',
    'Healthcare/Hospitals',
    'Commercial Buildings',
    'Power & Energy',
    'Renewable Energy',
    'Telecom & Utilities',
    'Water Treatment',
    'Other'
  ];

  const inquiryTypes = [
    'General Inquiry',
    'LT/HT Panel Design',
    'MCC/PCC Panel',
    'APFC Panel Solution',
    'Automation Upgrade',
    'Service & Maintenance',
    'Spare Parts',
    'Project Consultation'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (loading) return;

  setLoading(true);
  setError('');

  try {
    const response = await fetch(
      'https://vigneshwarapowercontrols.in/api/send-lead.php',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }
    );

    const result = await response.json();

    if (result.success) {
      setSubmitted(true);

      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        industry: '',
        inquiryType: 'General Inquiry',
        projectDetails: '',
        message: '',
        website: ''
      });

      setTimeout(() => setSubmitted(false), 6000);

    } else {
      setError(result.message || 'Submission failed');
    }

  } catch (err) {
    setError('Server not reachable. Please try again.');
  }

  setLoading(false);
};



  return (
    <>
      <style>{`
        :root {
          --blue: #0054A6;
          --red: #E42525;
          --dark: #0a1a2d;
          --gray: #4b5563;
          --light-bg: #f9fbfe;
        }
        /* ===== SIMPLE CONTACT HEADER ===== */

.contact-simple-header {
  background: #f5f5f5;
  padding: 70px 0 30px;
  text-align: center;
}

.contact-simple-header h2 {
  font-size: 28px;
  font-weight: 700;
  color: #d32f2f;
  margin-bottom: 8px;
}

.contact-simple-header p {
  font-size: 0.95rem;
  color: #000000;
  margin-bottom: 0;
}
        /* ================= CONTACT SECTIONS ================= */
        .contact-main {
          background: var(--light-bg);
          padding:  30px 0 80px;
        }

        .contact-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 24px;
        }

        /* Technical Form Section */
        .technical-form-section {
          background: #ffffff;
          border-radius: 16px;
          padding: 60px;
          box-shadow: 0 25px 60px rgba(0,0,0,0.08);
          border: 1px solid rgba(0,0,0,0.08);
          margin-bottom: 40px;
        }

        .section-eyebrow {
          font-size: 0.8rem;
          letter-spacing: 3px;
          font-weight: 800;
          color: var(--red);
          margin-bottom: 16px;
        }

        .section-title {
          font-size: 2.6rem;
          font-weight: 900;
          color: var(--dark);
          margin-bottom: 10px;
        }

        .section-subtitle {
          font-size: 1.1rem;
          color: var(--gray);
          margin-bottom: 40px;
          max-width: 700px;
        }

        /* Enhanced Form Styles */
        .tech-form .form-label {
          font-weight: 600;
          color: var(--dark);
          margin-bottom: 8px;
          font-size: 0.95rem;
        }

        .tech-form .form-control,
        .tech-form .form-select {
          border: 1px solid rgba(0,0,0,0.12);
          border-radius: 8px;
          padding: 14px 16px;
          font-size: 1rem;
          transition: all 0.3s ease;
          background: #fcfdfe;
        }

        .tech-form .form-control:focus,
        .tech-form .form-select:focus {
          border-color: var(--blue);
          box-shadow: 0 0 0 3px rgba(0,84,166,0.1);
          background: #fff;
        }

        .tech-form textarea.form-control {
          min-height: 150px;
          resize: vertical;
        }

        .submit-btn {
          background: linear-gradient(135deg, var(--blue) 0%, #004189 100%);
          border: none;
          padding: 16px 45px;
          font-weight: 700;
          font-size: 1.1rem;
          letter-spacing: 0.5px;
          border-radius: 10px;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .submit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 25px rgba(0,84,166,0.3);
        }

        .submit-btn:active {
          transform: translateY(0);
        }

        /* Contact Cards Section */
        .contact-cards-section {
  padding: 100px 0;
  background: #f8fbff;
}

.contact-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Main Row */
.contact-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 80px;
  flex-wrap: wrap;
}

/* LEFT SIDE */
.contact-left {
  flex: 1;
  min-width: 450px;
  text-align: left;
}

.section-eyebrow {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #e53935;
  margin-bottom: 15px;
}

.section-title {
  font-size: 3rem;
  font-weight: 900;
  margin-bottom: 20px;
  color: #0b1c2d;
}

.section-subtitle {
  font-size: 1.1rem;
  line-height: 1.7;
  color: #1b1a1a;
}

/* RIGHT SIDE */
.contact-right {
  flex: 1;
  display: flex;
  justify-content: flex-end; /* FULL RIGHT ALIGN */
}

/* Large Card */
.large-card {
  width: 100%;
  max-width: 520px;
  padding: 60px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 30px 70px rgba(0,0,0,0.08);
  text-align: center;
}
  .card-description {
  color: #000000;
}

.contact-icon {
  font-size: 36px;
  color: #007BFF;
  margin-bottom: 25px;
}

.contact-email,
.contact-phone {
  display: block;
  margin-top: 15px;
  font-weight: 600;
  color: #0054A6;
  text-decoration: none;
}


        /* Factory Visit Section */
        .factory-section {
          background: #ffffff;
          border-radius: 16px;
          padding: 60px;
          border: 2px solid rgba(0,84,166,0.1);
          position: relative;
          overflow: hidden;
        }

        .factory-section::before {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          width: 300px;
          height: 300px;
          background: linear-gradient(135deg, 
            rgba(0, 84, 166, 0.15) 0%, 
            rgba(228, 37, 37, 0.12) 45%,
            rgba(0, 84, 166, 0.08) 70%,
            rgba(228, 37, 37, 0.04) 100%);
          z-index: 1;
          border-radius: 0 0 0 100%;
          clip-path: polygon(100% 0, 0 0, 100% 100%);
        }

        .factory-content {
          position: relative;
          z-index: 2;
        }

        /* Alert Styling */
        .success-alert {
          background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
          border: 1px solid rgba(40,167,69,0.2);
          border-left: 4px solid #28a745;
          border-radius: 10px;
          padding: 20px;
          margin-bottom: 30px;
        }
        
        .error-alert {
          background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
          border: 1px solid rgba(220,53,69,0.2);
          border-left: 4px solid #dc3545;
          border-radius: 10px;
          padding: 15px;
          margin-bottom: 30px;
        }

        /* ================= RESPONSIVE ================= */
        @media (max-width: 992px) {
          .contact-header h1 {
            font-size: 2.8rem;
          }
          
          .contact-header-content {
            justify-content: center;
            text-align: center;
          }
          
          .contact-header-text {
            text-align: center;
            max-width: 800px;
          }
          
          .contact-header p {
            text-align: center;
          }
          
          .section-title {
            font-size: 2.2rem;
          }
          
          .contact-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          
          .technical-form-section,
          .factory-section {
            padding: 40px 30px;
          }
        }

        @media (max-width: 768px) {
          .contact-header {
            height: 60vh;
            min-height: 500px;
          }
          
          .contact-header h1 {
            font-size: 2.4rem;
          }
          
          .contact-header p {
            font-size: 1.1rem;
          }
          
          .contact-grid {
            grid-template-columns: 1fr;
          }
          
          .contact-main {
            padding: 70px 0;
          }
        }

        @media (max-width: 576px) {
          .contact-header h1 {
            font-size: 2rem;
          }
          
          .contact-header-text {
            text-align: center;
          }
          
          .contact-header p {
            text-align: center;
          }
          
          .technical-form-section,
          .factory-section {
            padding: 30px 20px;
          }
          /* ===== SIMPLE CONTACT HEADER ===== */


          .submit-btn {
            width: 100%;
          }
        }
      `}</style>

      {/* ================= MAIN CONTENT ================= */}
      <section className="contact-main">
        <section id="contact" className="contact-header">
  <div className="contact-container">

    <div className="section-header">

      <div className="section-eyebrow">
        CONTACT US
      </div>

      <h2 className="section-title">
        Engineering Consultation & Support
      </h2>

      <p className="section-subtitle">
        Get in touch with our engineering team for quotations,
        project discussions and technical consultation.
      </p>

    </div>

  </div>
</section>
        <div className="contact-container">
          
          {/* Technical Inquiry Form */}
          <div className="technical-form-section">
            <div className="section-eyebrow">TECHNICAL CONSULTATION</div>
            <h2 className="section-title">Submit Your Project Requirements</h2>
            <p className="section-subtitle">
              Provide details about your application, load requirements, and challenges. 
              Our engineering team will analyze and propose the optimal power control solution.
            </p>
            
            {submitted && (
              <Alert variant="success" className="success-alert">
                <strong>✅ Engineering inquiry submitted successfully!</strong><br />
                Our technical team will review your requirements and contact you within 24 hours.<br />
                <small>You will receive a confirmation email shortly.</small>
              </Alert>
            )}
            
            {error && (
              <Alert variant="danger" className="error-alert">
                <strong>⚠️ {error}</strong>
              </Alert>
            )}
            
            <Form onSubmit={handleSubmit} className="tech-form">
              {/* Honeypot Field - Anti Spam */}
<input
  type="text"
  name="website"
  value={formData.website}
  onChange={handleChange}
  style={{ position: 'absolute', left: '-5000px' }}
  autoComplete="off"
/>

              <Row className="g-4">
                <Col md={6}>
                  <Form.Group controlId="formName">
                    <Form.Label>Full Name *</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Enter your full name"
                    />
                  </Form.Group>
                </Col>
                
                <Col md={6}>
                  <Form.Group controlId="formEmail">
                    <Form.Label>Email Address *</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="Enter your professional email"
                    />
                  </Form.Group>
                </Col>
                
                <Col md={6}>
                  <Form.Group controlId="formPhone">
                    <Form.Label>Phone Number *</Form.Label>
                    <Form.Control
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      placeholder="Enter contact number"
                    />
                  </Form.Group>
                </Col>
                
                <Col md={6}>
                  <Form.Group controlId="formCompany">
                    <Form.Label>Company / Organization *</Form.Label>
                    <Form.Control
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      required
                      placeholder="Enter company name"
                    />
                  </Form.Group>
                </Col>
                
                <Col md={6}>
                  <Form.Group controlId="formIndustry">
                    <Form.Label>Industry / Sector *</Form.Label>
                    <Form.Select
                      name="industry"
                      value={formData.industry}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select your industry</option>
                      {industries.map((industry, idx) => (
                        <option key={idx} value={industry}>{industry}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                
                <Col md={6}>
                  <Form.Group controlId="formInquiryType">
                    <Form.Label>Inquiry Type *</Form.Label>
                    <Form.Select
                      name="inquiryType"
                      value={formData.inquiryType}
                      onChange={handleChange}
                      required
                    >
                      {inquiryTypes.map((type, idx) => (
                        <option key={idx} value={type}>{type}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                
                <Col md={12}>
                  <Form.Group controlId="formProjectDetails">
                    <Form.Label>Project Details / Requirements *</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="projectDetails"
                      value={formData.projectDetails}
                      onChange={handleChange}
                      required
                      rows={4}
                      placeholder="Describe your application, voltage, load details, specific challenges..."
                    />
                  </Form.Group>
                </Col>
                
                <Col md={12}>
                  <Form.Group controlId="formMessage">
                    <Form.Label>Additional Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows={3}
                      placeholder="Any additional information or specific compliance requirements..."
                    />
                  </Form.Group>
                </Col>
                
                <Col md={12} className="text-center mt-4">
                  <Button 
                    type="submit" 
                    className="submit-btn"
                    disabled={loading}
                  >
                    {loading ? 'Submitting...' : 'Request Engineering Consultation'}
                  </Button>
                  <p className="mt-2 text-muted" style={{fontSize: '0.85rem'}}>
                    Your information is secure. We respect your privacy.
                  </p>
                </Col>
              </Row>
            </Form>
          </div>
          
          {/* Contact Cards */}
<section className="contact-cards-section">
  <div className="contact-container">

    <div className="contact-row">

      {/* LEFT SIDE - TEXT */}
      <div className="contact-left">
        <div className="section-eyebrow">DIRECT LINES</div>

        <h2 className="section-title">
          Your Direct Lines to Precision Engineering
        </h2>

        <p className="section-subtitle">
          Connect with our expert team for technical support, quotations,
          and project discussions. We ensure fast response and professional
          assistance for all your electrical panel and turnkey project needs.
        </p>
      </div>

      {/* RIGHT SIDE - GENERAL INQUIRIES CARD */}
      <div className="contact-right">
        <div className="contact-card large-card">
          <div className="contact-icon">
            <FaHeadset />
          </div>

          <h3>General Inquiries</h3>
          <p className="card-description">
  Company details, documentation & basic information
</p>

          <a
            href="mailto:info@vigneshwarapowercontrols.in"
            className="contact-email"
          >
            info@vigneshwarapowercontrols.in
          </a>

          <a
            href="https://wa.me/917396748509"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-phone"
          >
            +91 73967 48509
          </a>
        </div>
      </div>

    </div>

  </div>
</section>

          {/* Factory Visit & Location with Google Image */}
          <div className="factory-section">
            <div className="factory-content">
              <div className="section-eyebrow">VISIT OUR FACILITY</div>
              <h2 className="section-title">Manufacturing Excellence On Display</h2>
              <p className="section-subtitle">
                Visit our manufacturing facility to see our quality controls, 
                testing processes, and engineering capabilities firsthand.
              </p>
              
              {/* Google Image on Right & Location on Left - Side by Side */}
              <Row className="g-5 mt-5 align-items-stretch">
                {/* Left Column: Location Details */}
                <Col md={6}>
                  <div className="contact-card" style={{ 
                    textAlign: 'left', 
                    padding: '30px',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between'
                  }}>
                    <div>
                      <div className="d-flex align-items-start mb-4">
                        <FaMapMarkerAlt className="me-3" style={{ color: 'var(--blue)', fontSize: '24px', marginTop: '4px' }} />
                        <div>
                          <h4 style={{ fontSize: '1.4rem', marginBottom: '12px', color: '#000000', fontWeight: '900', letterSpacing: '0.3px' }}>Head Office & Manufacturing Facility</h4>
                          <p style={{ marginBottom: '8px', color: 'var(--gray)' }}>
                            <strong>Vigneshwara Power Controls</strong>
                          </p>
                          <p style={{ marginBottom: '8px', color: 'var(--gray)' }}>
                            Building No. 275, Phase-1 & 2, Block No-16,
                          </p>
                          <p style={{ marginBottom: '8px', color: 'var(--gray)' }}>
                            Near SBI Branch, Auto Nagar,
                          </p>
                          <p style={{ color: 'var(--gray)' }}>
                            Guntur, Andhra Pradesh – 522001
                          </p>
                        </div>
                      </div>
                      
                      <div className="d-flex align-items-start mb-4">
                        <FaPhone className="me-3" style={{ color: 'var(--blue)', fontSize: '24px', marginTop: '4px' }} />
                        <div>
                          <h4 style={{ fontSize: '1.4rem', marginBottom: '12px', color: '#000000', fontWeight: '900', letterSpacing: '0.3px' }}>Contact Numbers</h4>
                          <p style={{ marginBottom: '8px', color: 'var(--gray)' }}>
                            <strong>Ph No. :</strong> +91-7396748509
                          </p>
                        </div>
                      </div>
                      
                      <div className="d-flex align-items-start mb-4">
                        <FaClock className="me-3" style={{ color: 'var(--blue)', fontSize: '24px', marginTop: '4px' }} />
                        <div>
                          <h4 style={{ fontSize: '1.4rem', marginBottom: '12px', color: '#000000', fontWeight: '900', letterSpacing: '0.3px' }}>Business Hours</h4>
                          <p style={{ marginBottom: '8px', color: 'var(--gray)' }}>
                            <strong>Monday - Saturday:</strong> 10:00 AM - 7:00 PM
                          </p>
                          <p style={{ color: 'var(--gray)' }}>
                            <strong>Sunday:</strong> Closed (Emergency service available)
                          </p>
                        </div>
                      </div>

                      <div className="d-flex align-items-start">
                        <FaEnvelope className="me-3" style={{ color: 'var(--blue)', fontSize: '24px', marginTop: '4px' }} />
                        <div>
                          <h4 style={{ fontSize: '1.4rem', marginBottom: '12px', color: '#000000', fontWeight: '900', letterSpacing: '0.3px' }}>Email Contacts</h4>      
                          <p>
                            <a href="mailto:info@vigneshwarapowercontrols.in" className="contact-email">
                              info@vigneshwarapowercontrols.in
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Right Column: Google Image and Embedded Map */}
                <Col md={6}>
                  <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    {/* Image Section */}
                    <div className="google-image-container" style={{ 
                      width: '100%', 
                      height: '350px',
                      borderRadius: '16px',
                      overflow: 'hidden',
                      position: 'relative',
                      border: '2px solid rgba(0,84,166,0.15)',
                      boxShadow: '0 20px 40px rgba(0,0,0,0.08)'
                    }}>
                      <img 
                        src={manufacturingImage} 
                        alt="VPC Manufacturing Facility"
                        style={{ 
                          width: '100%', 
                          height: '100%', 
                          objectFit: 'cover'
                        }}
                      />
                      {/* Image Overlay Text */}
                      <div style={{
                        position: 'absolute',
                        bottom: '0',
                        left: '0',
                        right: '0',
                        background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.7) 70%, transparent 100%)',
                        color: 'white',
                        padding: '4px 12px',
                      }}>
                        <h3 style={{ 
                          fontSize: '2rem',  
                          fontWeight: '700',
                          marginBottom: '1px',
                          lineHeight: '1.1'
                        }}>
                          Manufacturing Workspace
                        </h3>
                        <p style={{ 
                          fontSize: '1rem',  
                          opacity: '0.9',
                          marginBottom: '0',
                          lineHeight: '1'
                        }}>
                          Precision engineering & quality control
                        </p>
                      </div>
                    </div>
                    
                    {/* Embedded Google Map */}
                    <div style={{
                      marginTop: '12px',
                      width: '100%',
                      height: '350px',
                      borderRadius: '16px',
                      overflow: 'hidden',
                      border: '2px solid rgba(0,84,166,0.10)',
                      boxShadow: '0 8px 24px rgba(0,0,0,0.06)'
                    }}>
                      <iframe
                        title="VPC Location Map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15315.771135878473!2d80.4790622!3d16.3258675!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35f50001d78d4b%3A0x17fe9d8f8d46aa98!2sVigneshwara%20Power%20Controls!5e0!3m2!1sen!2sin!4v1770835671072!5m2!1sen!2sin"
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                      ></iframe>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;